module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-180x180-c51ba624235909f54878f8c108847de1.png";